import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * 確認画面のお車の状況の種別
 */
const TroubleInfoType: React.FC<TroubleInfoTypeProps> = (props) => {
  return (
    <TroubleInfoTypeContent>
      {props.icon}
      <TextArea>
        <Text>{props.label}</Text>
      </TextArea>
    </TroubleInfoTypeContent>
  )
}

export type TroubleInfoTypeProps = {
  icon: React.ReactNode
  label: string
}

const TroubleInfoTypeContent = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
  margin-left: 16px;
`

const TextArea = styled.div`
  flex: 1;
  margin-left: 8px;
`

export default TroubleInfoType
